export type { BridgeLoginCommand, BridgeLoginResult } from "../types";

/** v1 旧格式消息类型（用于 fallback 兼容） */
export interface BridgeV1AuthState {
  type: "firebase-auth-state";
  action: "login" | "logout" | "login-failed";
  idToken?: string;
  email?: string;
  displayName?: string;
  error?: { code: string; message: string };
}

/** 合法 origin 白名单 */
export const BRIDGE_ALLOWED_ORIGINS = [
  "https://www.edwealth.ai",
  "https://ed.beta.edwealth.ai",
  "https://ed.pre.edwealth.ai",
  "http://localhost:3003",
  "", // native WebView origin (no origin header)
] as const;
